import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const Watch = () => {
  return (
    <div>
      <Navbar />
      Watch
      <Footer />

    </div>
  )
}

export default Watch
